import { withNamespaces } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const CancelModal = ({ t, isOpen, toggle }) => {
    const history = useHistory();

    return (
        <Modal isOpen={isOpen} toggle={toggle} aria-labelledby="cancel-declaration-title">
            <ModalHeader toggle={toggle} id="cancel-declaration-title">
                {t('Cancel Declaration')}
            </ModalHeader>
            <ModalBody id="cancel-declaration-desc">
                {t('Are you sure you want to cancel this declaration process?')}
                {t('Any unsaved progress will be lost.')}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('Continue Declaration')}
                </Button>
                <Button 
                    color="danger" 
                    onClick={() => history.push('/third-party/3rd-party/eudr-due-diligence')}
                >
                    {t('Yes, Cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    CancelModal
);
